var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('query-tag'),_c('rev-card-container',{attrs:{"reviewables":_vm.reviewables}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }